/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from 'react';

const useLocalStorage = (key: string, initialValue?: any) => {
  const [storedValue, setStoredValue] = useState(() => {
    const item = localStorage.getItem(key);
    if (item) return JSON.parse(item);
    if (initialValue) {
      localStorage.setItem(key, JSON.stringify(initialValue));
      return initialValue;
    }
    return null;
  });

  const setValue = useCallback(
    (value: any) => {
      setStoredValue(value);
      localStorage.setItem(key, JSON.stringify(value));
    },
    [key]
  );

  const removeValue = useCallback(() => {
    setStoredValue(null);
    localStorage.removeItem(key);
  }, [key]);

  return { storedValue, setValue, removeValue };
};

export default useLocalStorage;
